module.exports = __webpack_public_path__ + "img/375.34704e72.jpg";